import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { HueProvider } from "./HueContext";
import "./App.css";
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HueProvider>
    <App />
  </HueProvider>
);